/** @format */

import { Layout } from "./src/Layout"
export default Layout
